var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"cd98eb773facaeee89e0387ff414cbdec61af106"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["youngbrutegangxyz@zacs-team"]={id:"cd98eb773facaeee89e0387ff414cbdec61af106"};
      